import { createFeatureSelector, createSelector } from '@ngrx/store';

import { selectBookstores } from '®app/ngrx';
import { LoadableFactory } from '®shared/data';
import { Bookstore } from '®shared/tenant';

import { BookstoreAndAvailability } from './bookstore-and-availability';
import { LoadableBookstoreAvailability } from './bookstore-availability';

export const STATE_BOOKSTORE_AVAILABILITY = 'bookstoreAvailability';

export type BookstoreAvailabilityByBookstore = {
  [bookstoreId: string]: LoadableBookstoreAvailability;
};

export type BookstoreAvailabilityState = {
  [resourceId: string]: BookstoreAvailabilityByBookstore;
};

export const BOOKSTORE_AVAILABILITY_INITIAL_STATE: BookstoreAvailabilityState =
  {};

export const selectBookstoreAvailabilityState =
  createFeatureSelector<BookstoreAvailabilityState>(
    STATE_BOOKSTORE_AVAILABILITY,
  );

export const getBookstoreAvailabilityForResourceId =
  (resourceId: string) =>
  (state: BookstoreAvailabilityState): BookstoreAvailabilityByBookstore =>
    (state && state[resourceId]) || null;

export const getBookstoreAvailabilityForResourceIdAndBookstoreId =
  (resourceId: string, bookstoreId: string) =>
  (state: BookstoreAvailabilityState): LoadableBookstoreAvailability => {
    const availability =
      getBookstoreAvailabilityForResourceId(resourceId)(state);
    return (availability && availability[bookstoreId]) || null;
  };

export const selectBookstoreAvailabilityForResourceId = (resourceId: string) =>
  createSelector(
    selectBookstoreAvailabilityState,
    getBookstoreAvailabilityForResourceId(resourceId),
  );

export const selectBookstoresAndAvailabilitiesForResourceId = (
  resourceId: string,
) =>
  createSelector(
    selectBookstoreAvailabilityForResourceId(resourceId),
    selectBookstores,
    (
      availabilityByBookstore: BookstoreAvailabilityByBookstore,
      bookstores: Bookstore[],
    ) =>
      bookstores &&
      bookstores.map(
        bookstore =>
          new BookstoreAndAvailability(
            bookstore,
            availabilityByBookstore
              ? availabilityByBookstore[bookstore.id]
              : LoadableFactory.reset(),
          ),
      ),
  );

export function getInitialBookstoreAvailabilityState(): BookstoreAvailabilityState {
  return BOOKSTORE_AVAILABILITY_INITIAL_STATE;
}
